const currencyLocales = {
  USD: { locale: 'en-US', decimals: 2 }, // United States Dollar
  INR: { locale: 'en-IN', decimals: 2 }, // Indian Rupee
  EUR: { locale: 'de-DE', decimals: 2 }, // Euro (Germany)
  JPY: { locale: 'ja-JP', decimals: 0 }, // Japanese Yen
  GBP: { locale: 'en-GB', decimals: 2 }, // British Pound
  AUD: { locale: 'en-AU', decimals: 2 }, // Australian Dollar
  CAD: { locale: 'en-CA', decimals: 2 }, // Canadian Dollar
  CHF: { locale: 'de-CH', decimals: 2 }, // Swiss Franc
  CNY: { locale: 'zh-CN', decimals: 2 }, // Chinese Yuan
  SEK: { locale: 'sv-SE', decimals: 2 }, // Swedish Krona
  NZD: { locale: 'en-NZ', decimals: 2 }, // New Zealand Dollar
  MXN: { locale: 'es-MX', decimals: 2 }, // Mexican Peso
  SGD: { locale: 'en-SG', decimals: 2 }, // Singapore Dollar
  HKD: { locale: 'zh-HK', decimals: 2 }, // Hong Kong Dollar
  NOK: { locale: 'nb-NO', decimals: 2 }, // Norwegian Krone
  KRW: { locale: 'ko-KR', decimals: 0 }, // South Korean Won
  TRY: { locale: 'tr-TR', decimals: 2 }, // Turkish Lira
  RUB: { locale: 'ru-RU', decimals: 2 }, // Russian Ruble
  ZAR: { locale: 'en-ZA', decimals: 2 }, // South African Rand
  BRL: { locale: 'pt-BR', decimals: 2 }, // Brazilian Real
  MYR: { locale: 'ms-MY', decimals: 2 }, // Malaysian Ringgit
  THB: { locale: 'th-TH', decimals: 2 }, // Thai Baht
  IDR: { locale: 'id-ID', decimals: 0 }, // Indonesian Rupiah
  PHP: { locale: 'en-PH', decimals: 2 }, // Philippine Peso
  PLN: { locale: 'pl-PL', decimals: 2 }, // Polish Zloty
  DKK: { locale: 'da-DK', decimals: 2 }, // Danish Krone
  HUF: { locale: 'hu-HU', decimals: 2 }, // Hungarian Forint
  CZK: { locale: 'cs-CZ', decimals: 2 }, // Czech Koruna
  ILS: { locale: 'he-IL', decimals: 2 }, // Israeli Shekel
  CLP: { locale: 'es-CL', decimals: 0 }, // Chilean Peso
  PKR: { locale: 'ur-PK', decimals: 2 }, // Pakistani Rupee
  VND: { locale: 'vi-VN', decimals: 0 }, // Vietnamese Dong
  AED: { locale: 'ar-AE', decimals: 2 }, // UAE Dirham
  SAR: { locale: 'ar-SA', decimals: 2 }, // Saudi Riyal
  BDT: { locale: 'bn-BD', decimals: 2 }, // Bangladeshi Taka
  LKR: { locale: 'si-LK', decimals: 2 }, // Sri Lankan Rupee
  NGN: { locale: 'en-NG', decimals: 2 }, // Nigerian Naira
  KES: { locale: 'sw-KE', decimals: 2 }, // Kenyan Shilling
  EGP: { locale: 'ar-EG', decimals: 2 }, // Egyptian Pound
  COP: { locale: 'es-CO', decimals: 2 }, // Colombian Peso
  PEN: { locale: 'es-PE', decimals: 2 }, // Peruvian Sol
  ARS: { locale: 'es-AR', decimals: 2 }, // Argentine Peso
  UAH: { locale: 'uk-UA', decimals: 2 }, // Ukrainian Hryvnia
  RON: { locale: 'ro-RO', decimals: 2 }, // Romanian Leu
  BGN: { locale: 'bg-BG', decimals: 2 }, // Bulgarian Lev
  HRK: { locale: 'hr-HR', decimals: 2 }, // Croatian Kuna
  ISK: { locale: 'is-IS', decimals: 0 }, // Icelandic Krona
  JMD: { locale: 'en-JM', decimals: 2 }, // Jamaican Dollar
  TWD: { locale: 'zh-TW', decimals: 2 }, // New Taiwan Dollar
  QAR: { locale: 'ar-QA', decimals: 2 }, // Qatar Riyal
  BHD: { locale: 'ar-BH', decimals: 3 }, // Bahraini Dinar
  LBP: { locale: 'ar-LB', decimals: 2 }, // Lebanese Pounds
  KWD: { locale: 'ar-KW', decimals: 3 }, // Kuwaiti Dinar
  MNT: { locale: 'mn-MN', decimals: 2 }, // Mongolian Tugrik
  UZS: { locale: 'uz-UZ', decimals: 2 }, // Uzbekistani Som
  GEL: { locale: 'ka-GE', decimals: 2 }, // Georgian Lari
  AMD: { locale: 'hy-AM', decimals: 2 }, // Armenian Dram
  AZN: { locale: 'az-AZ', decimals: 2 }, // Azerbaijani Manat
  IQD: { locale: 'ar-IQ', decimals: 3 }, // Iraqi Dinar
  IRR: { locale: 'fa-IR', decimals: 2 }, // Iranian Rial
  AFN: { locale: 'ps-AF', decimals: 2 }, // Afghan Afghani
  KZT: { locale: 'kk-KZ', decimals: 2 }, // Kazakhstani Tenge
  BYN: { locale: 'be-BY', decimals: 2 }, // Belarusian Ruble
  MAD: { locale: 'ar-MA', decimals: 2 }, // Moroccan Dirham
  TND: { locale: 'ar-TN', decimals: 3 }, // Tunisian Dinar
  OMR: { locale: 'ar-OM', decimals: 3 }, // Omani Rial
  DZD: { locale: 'ar-DZ', decimals: 2 }, // Algerian Dinar
  LYD: { locale: 'ar-LY', decimals: 3 }, // Libyan Dinar
  SDG: { locale: 'ar-SD', decimals: 2 }, // Sudanese Pound
  XAF: { locale: 'fr-CM', decimals: 0 }, // Central African CFA Franc
  XOF: { locale: 'fr-BF', decimals: 0 }, // West African CFA Franc
  MVR: { locale: 'dv-MV', decimals: 2 }, // Maldivian Rufiyaa
  KGS: { locale: 'ky-KG', decimals: 2 }, // Kyrgyzstani Som
  JOD: { locale: 'ar-JO', decimals: 3 }, // Jordanian Dinar
};
  
export const formatStoreCurrency = (amount, currency) => {
  const currencyCode = currency || sessionStorage.getItem("qcStoreCurrencyCode");
  const locale = currencyLocales[currencyCode]?.locale || 'en-IN';
  const decimals = currencyLocales[currencyCode]?.decimals || 2; // Default to 2 decimal places if not specified

  const value = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
  }).format(amount);

  return value;
};

export const isIndia = () => {
  return sessionStorage.getItem("qcStoreCurrencyCode") === "INR";
};

export const gcValidityMonths = [
  { title: "1 Month", value: "1" },
  { title: "2 Months", value: "2" },
  { title: "3 Months", value: "3" },
  { title: "6 Months", value: "6" },
  { title: "9 Months", value: "9" },
  { title: "12 Months", value: "12" },
  { title: "18 Months", value: "18" },
  { title: "24 Months", value: "24" },
]

export const gcValidityYears=[
  { title: "1 Year", value: "1" },
  { title: "2 Years", value: "2" },
  { title: "3 Years", value: "3" },
  { title: "4 Years", value: "4" },
  { title: "5 Years", value: "5" },
]